import { gql } from '@apollo/client';

export const CUSTOM_PACING_LINE_ITEM_ERROR = gql`
  fragment customPacingLineItemError on CustomPacingLineItemError {
    lineItemId
    status
    errorCode
    errorMessage
  }
`;
